// Compact support facts live beside the published procedures. Both chat and
// the generated agent-skill reference use this renderer.
const { pages } = require('./nativeAppGuides.json');

const START = '<gab-ai-native-app-support>';
const END = '</gab-ai-native-app-support>';

function renderNativeAppOverview() {
  return [
    '## Native apps, Mac Work and mobile Remote', '',
    'Get the direct-download Mac app and check public availability at https://gab.ai/mac. Get iOS and Android at https://gab.ai/download. The current guides below cover compatible builds; a beta/source feature is not necessarily in the public installer.', '',
    'Mac Work can use approved local folders, browser tabs and supported apps. Remote pairs the iOS/Android app to the same-account Mac for shared project tasks. Keep the Mac awake, online and Gab AI running; file and browser/app contents used by Work are processed in the cloud. Remote is not screen sharing or an offline model. Voice is available in Chat on compatible Mac builds; Work uses dictation.', '',
    ...pages.map(page => `- [${page.title}](https://gab.ai${page.canonicalPath}): ${page.description}`),
    '- [Browser extension](https://gab.ai/extension): Brave/Chrome side chat and page context; connecting a compatible Mac app adds Work automation.',
  ].join('\n');
}

function renderNativeAppSupport() {
  return [
    '# Mac app, browser access and mobile Remote support',
    '',
    'These current native-app facts take precedence over older statements about Mac distribution, voice, local files, browser access or Remote elsewhere in the support knowledge base. Availability depends on the installed app and enabled services; check the public download and the user’s app before promising a released feature.',
    ...pages.flatMap(page => [
      '', `## ${page.title}`, '', `Guide: https://gab.ai${page.canonicalPath}`, '',
      ...page.supportNotes.map(note => `- ${note}`),
    ]),
  ].join('\n');
}

function withNativeAppSupport(knowledgeBase) {
  // Admins may have saved a previous default, including this section. Replace
  // only the managed block; preserve their other support policies and copy.
  const base = String(knowledgeBase || '')
    .replace(/<gab-ai-native-app-support>[\s\S]*?<\/gab-ai-native-app-support>/g, '')
    .trim();
  return [base, `${START}\n${renderNativeAppSupport()}\n${END}`].filter(Boolean).join('\n\n');
}

module.exports = { renderNativeAppSupport, renderNativeAppOverview, withNativeAppSupport };
